import { render, staticRenderFns } from "./SpecialWaste.vue?vue&type=template&id=2e6b54fb&scoped=true"
import script from "./SpecialWaste.vue?vue&type=script&lang=js"
export * from "./SpecialWaste.vue?vue&type=script&lang=js"
import style0 from "./SpecialWaste.vue?vue&type=style&index=0&id=2e6b54fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b54fb",
  null
  
)

export default component.exports